<mat-card appearance="outlined">
    <mat-card-title>{{ "MAIN_APP_OBJECTS.objektSchutz" | translate }}</mat-card-title>
    <mat-card-content [formGroup]="formGroupObjPW">
        <mat-form-field>
            <mat-label>Objekt</mat-label>
            <input matInput formControlName="fldObj" />
        </mat-form-field>
        
        <mat-form-field>
            <mat-label>Passwort</mat-label>
            <input matInput formControlName="fldObjPW" required type="password"/>
        </mat-form-field>
    </mat-card-content>

    <mat-dialog-actions>
	    <button (click)="checkPW()" class="confirm" mat-stroked-button
        [disabled]="!formGroupObjPW.valid" [innerText]="'MAIN_APP_DIALOG.ok' | translate"></button>
        <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
    </mat-dialog-actions>
</mat-card>
